module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av538-325c443454ff185fadd24b1c2eecb433.jpg";